export type Tab = {
  type: "live" | "schedule" | "cancelled" | "prizeDistributed";
  title: string;
};

export const TABS: Tab[] = [
  {
    type: "schedule",
    title: "開催予定",
  },
  {
    type: "live",
    title: "開催中",
  },
  {
    type: "prizeDistributed",
    title: "結果",
  },
];
